import { IDepartment, IJobData, IJob } from '../index'

export default function flattenOfficeData(data: IJobData) {
  const officeData = data.offices.reduce((accum: IDepartment[], office) => {
    office.departments.forEach((department) => {
      const existingDep = accum.find((dept) => dept.id === department.id)
      if (existingDep) {
        const combinedJobs = existingDep.jobs.concat(department.jobs)
        existingDep.jobs = combinedJobs
      } else {
        const newDepartment: IDepartment = {
          ...department,
          jobs: Array.from(department.jobs),
        }
        accum.push(newDepartment)
      }
    })

    return accum
  }, [])

  // filter out duplicate jobs by id
  officeData.forEach((dept) => {
    const jobMap = new Map<number, IJob>()

    for (const job of dept.jobs) {
      jobMap.set(job.id, job)
    }
    dept.jobs = Array.from(jobMap.values())
  })

  return officeData
}
